import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { confirmSettlement, getSettlementAuditList, getSettlementRecords } from "@/api/merchant";
import { getDict } from "@/utils/dictionary";
import GoogleCodeDialog from "@/components/GoogleCodeDialog";
export default {
  name: "SettlementConfirmation",
  components: {
    GoogleCodeDialog: GoogleCodeDialog
  },
  data: function data() {
    return {
      isLoading: false,
      tableData: [],
      payModeList: [],
      // 支付方式字典数据
      searchInfo: {
        merchantId: ""
      },
      // 弹窗相关
      detailDialogVisible: false,
      detailLoading: false,
      detailTableData: [],
      detailTotal: 0,
      detailPage: 1,
      detailPageSize: 10,
      currentDetailParams: null,
      // 当前详情查询参数

      // 详情表格列定义
      detailColumns: [{
        prop: "tradeDate",
        label: "交易时间"
      }, {
        prop: "payMode",
        label: "渠道"
      }, {
        prop: "tradeAmount",
        label: "交易金额"
      }, {
        prop: "feeAmount",
        label: "手续费",
        isPercent: true
      }, {
        prop: "settleAmount",
        label: "待结算金额"
      }, {
        prop: "settleCycle",
        label: "结算方式"
      }, {
        prop: "status",
        label: "结算状态"
      }, {
        prop: "settleDate",
        label: "结算日期"
      }],
      // Google验证码相关
      googleCodeDialogVisible: false,
      googleCode: "",
      currentSettlementDate: null // 当前确认结算的日期
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return _this.getPayModeDict();
          case 1:
            _context.next = 2;
            return _this.getTableData();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    // 获取支付方式字典
    getPayModeDict: function getPayModeDict() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, _t;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return getDict("payMode");
            case 1:
              res = _context2.sent;
              if (res) {
                _this2.payModeList = res;
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t = _context2["catch"](0);
              console.error("获取支付方式字典失败:", _t);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 2]]);
      }))();
    },
    // 获取表格数据
    getTableData: function getTableData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, _t2;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _this3.isLoading = true;
              _context3.next = 1;
              return getSettlementAuditList(_this3.searchInfo);
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                _this3.tableData = res.data || [];
              } else {
                _this3.$message.error(res.msg || "获取数据失败");
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t2 = _context3["catch"](0);
              console.error("获取结算审核列表失败:", _t2);
              _this3.$message.error("获取数据失败");
            case 3:
              _context3.prev = 3;
              _this3.isLoading = false;
              return _context3.finish(3);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 2, 3, 4]]);
      }))();
    },
    // 查询
    handleSearch: function handleSearch() {
      this.getTableData();
    },
    // 重置
    handleReset: function handleReset() {
      this.searchInfo = {
        merchantId: ""
      };
      this.getTableData();
    },
    // 获取支付方式金额
    getPayModeAmount: function getPayModeAmount(row, payModeLabel) {
      var group = row.payModeGroups.find(function (g) {
        return g.payMode === payModeLabel;
      });
      if (!group) return "0.00"; // 数据不存在时显示0
      return this.formatAmount(group.totalAmount);
    },
    // 获取支付方式商户数
    getPayModeMerchantCount: function getPayModeMerchantCount(row, payModeLabel) {
      var group = row.payModeGroups.find(function (g) {
        return g.payMode === payModeLabel;
      });
      if (!group) return "0"; // 数据不存在时显示0
      return group.merchantCount || 0;
    },
    // 格式化金额
    formatAmount: function formatAmount(amount) {
      if (amount === undefined || amount === null) return "0.00";
      return (parseFloat(amount) / 100).toFixed(2);
    },
    // 格式化手续费（添加百分号）
    formatFee: function formatFee(fee) {
      if (fee === undefined || fee === null) return "0%";
      return "".concat(fee, "%");
    },
    // 获取审核状态标签类型
    getAuditStatusTagType: function getAuditStatusTagType(status) {
      var statusMap = {
        1: "warning",
        // 待审核
        2: "success",
        // 已审核
        3: "danger" // 已拒绝
      };
      return statusMap[status] || "info";
    },
    // 获取审核状态文本
    getAuditStatusText: function getAuditStatusText(status) {
      var statusMap = {
        1: "待审核",
        2: "已审核",
        3: "已拒绝"
      };
      return statusMap[status] || "未知";
    },
    // 获取结算状态标签类型
    getSettledStatusTagType: function getSettledStatusTagType(status) {
      return status === 2 ? "success" : "info";
    },
    // 获取结算状态文本
    getSettledStatusText: function getSettledStatusText(status) {
      return status === 2 ? "已结算" : "未结算";
    },
    // 查看详情（点击某个支付方式下的详情按钮）
    handleDetail: function handleDetail(row, payModeLabel) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this4.currentDetailParams = {
                startDate: row.date,
                endDate: row.date,
                payMode: payModeLabel,
                dateType: 2
              };
              _this4.detailDialogVisible = true;
              _this4.detailPage = 1;
              _context4.next = 1;
              return _this4.getDetailData();
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 获取详情数据（带分页）
    getDetailData: function getDetailData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res, _t3;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _this5.detailLoading = true;
              _context5.next = 1;
              return getSettlementRecords(_objectSpread(_objectSpread({}, _this5.currentDetailParams), {}, {
                page: _this5.detailPage,
                pageSize: _this5.detailPageSize
              }));
            case 1:
              res = _context5.sent;
              if (res.code === 0) {
                _this5.detailTableData = res.data.list || [];
                _this5.detailTotal = res.data.total || 0;
              } else {
                _this5.$message.error(res.msg || "获取详情失败");
              }
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t3 = _context5["catch"](0);
              console.error("获取详情失败:", _t3);
              _this5.$message.error("获取详情失败");
            case 3:
              _context5.prev = 3;
              _this5.detailLoading = false;
              return _context5.finish(3);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 2, 3, 4]]);
      }))();
    },
    // 详情分页 - 页码改变
    handleDetailPageChange: function handleDetailPageChange(page) {
      this.detailPage = page;
      this.getDetailData();
    },
    // 详情分页 - 每页条数改变
    handleDetailSizeChange: function handleDetailSizeChange(size) {
      this.detailPageSize = size;
      this.detailPage = 1;
      this.getDetailData();
    },
    // 确认结算
    handleConfirmSettlement: function handleConfirmSettlement(row) {
      var _this6 = this;
      var confirmMsg = "\u786E\u8BA4\u7ED3\u7B97 ".concat(row.date, " \u7684\u8BA2\u5355\u5417\uFF1F\u603B\u91D1\u989D\uFF1A").concat(this.formatAmount(row.totalAmount));
      this.$confirm(confirmMsg, "确认结算", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        // 保存当前要确认结算的日期
        _this6.currentSettlementDate = row.date;
        // 打开Google验证码弹窗
        _this6.googleCodeDialogVisible = true;
      }).catch(function () {
        // 用户取消操作
      });
    },
    // 关闭Google验证码弹窗
    closeGoogleCodeDialog: function closeGoogleCodeDialog() {
      this.googleCodeDialogVisible = false;
      this.googleCode = "";
      this.currentSettlementDate = null;
    },
    // 确认Google验证码
    confirmGoogleCode: function confirmGoogleCode() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res, _t4;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (_this7.googleCode) {
                _context6.next = 1;
                break;
              }
              _this7.$message.error("请输入Google验证码");
              return _context6.abrupt("return");
            case 1:
              if (!(_this7.googleCode.length !== 6)) {
                _context6.next = 2;
                break;
              }
              _this7.$message.error("Google验证码应为6位数字");
              return _context6.abrupt("return");
            case 2:
              _context6.prev = 2;
              _context6.next = 3;
              return confirmSettlement({
                date: _this7.currentSettlementDate,
                google_code: _this7.googleCode
              });
            case 3:
              res = _context6.sent;
              if (!(res.code === 0)) {
                _context6.next = 5;
                break;
              }
              _this7.$message.success("结算确认成功");
              _this7.closeGoogleCodeDialog();
              _context6.next = 4;
              return _this7.getTableData();
            case 4:
              _context6.next = 6;
              break;
            case 5:
              _this7.$message.error(res.msg || "结算确认失败");
            case 6:
              _context6.next = 8;
              break;
            case 7:
              _context6.prev = 7;
              _t4 = _context6["catch"](2);
              console.error("确认结算失败:", _t4);
              _this7.$message.error("结算确认失败");
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[2, 7]]);
      }))();
    }
  }
};